<template>
    <div class="layout-general-fonts space-y-5 lg:space-y-10 xl:space-y-14">
        <div class="uppercase font-semibold">
            {{ $t('layout.config.fontSettings') }}
        </div>
        <div class="layout-general-fonts__content space-y-5 lg:space-y-10 xl:space-y-14">
            <RedesignVerticalFormItem
                v-for="fontItem in FONT_GENERAL_SETTINGS"
                :key="fontItem.key"
                :title="String($t(fontItem.label))"
                class="layout-general-fonts__content-item"
            >
                <LayoutFontSettings
                    v-model="localParametersModel"
                    :settings="fontItem"
                />
            </RedesignVerticalFormItem>
        </div>
    </div>
</template>

<script setup lang="ts">
import RedesignVerticalFormItem from '@/components/RedesignBaseComponents/Form/RedesignVerticalFormItem.vue'
import { ILayoutItem } from '@/types/dashboard'
import { useVModel } from '@vueuse/core'
import LayoutFontSettings from '@/components/RedesignComponents/Layout/Common/LayoutFontSettings.vue'
import { computed } from 'vue'
import { layoutDefaultColors } from '@/enum/colors'

type SettingType = {
    key: string,
    colorParameterName: string
    fontParameterName: string
    label: string
    defaultColor: string
    defaultSize: number
}

const FONT_GENERAL_SETTINGS: Array<SettingType> = [
    {
        key: 'mainText',
        colorParameterName: 'MainTextColor',
        fontParameterName: 'FontSize',
        label: 'layout.config.fontSize',
        defaultSize: 16,
        defaultColor: layoutDefaultColors.mainTextColor
    },
    {
        key: 'groupTabs',
        colorParameterName: 'ColorWidgetGroupTitles',
        fontParameterName: 'WidgetGroupTitlesFontSize',
        label: 'layout.config.widgetGroupTitlesFontSize',
        defaultSize: 16,
        defaultColor: layoutDefaultColors.widgetGroupTitles
    }
]

const props = defineProps<{
    value: ILayoutItem
}>()

const emit = defineEmits<{
    (e: 'input', value: ILayoutItem): void
    (e: 'update:value', value: ILayoutItem): void
}>()

const layoutLocalModel = useVModel(props, 'value', emit, { eventName: 'input' })

const localParametersModel = computed({
    get () {
        return layoutLocalModel.value.LayoutParametersList
    },
    set (value) {
        layoutLocalModel.value.LayoutParametersList = [ ...value ]
    }
})
</script>
